export const clientConfiguration = {
    "authority": `${window.authSchema}://${window.authUrl}/`,
    "client_id": window.clientId,
    "redirect_uri": `${window.location.protocol}//${window.location.host}/callback`,
    "silent_redirect_uri": `${window.location.protocol}//${window.location.host}/callback`,
    "post_logout_redirect_uri": `${window.location.protocol}//${window.location.host}/callback`,
    "manage_account_redirect_uri": `${window.authSchema}://${window.authUrl}/manage`
};

export const scope = "openid email profile phone offline_access";
export const sessionCheckScope = "openid";

export const apiDataManagerBaseURL = `${window.apiSchema}://${window.apiDataManagerUrl}/api/v1/`;
export const apiBusSchedBaseURL = `${window.apiSchema}://${window.apiBusSchedUrl}/api/v1/`;
export const apiBusMapBaseURL = `${window.apiSchema}://${window.apiBusMapUrl}/api/v1/busmap/`;
export const apiFilesBaseURL = `${window.apiSchema}://${window.apiFilesUrl}/api/v1/`;
export const apiSpiderMapBaseURL = `${window.apiSchema}://${window.apiSpiderMapUrl}/api/v1/`;
export const apiSchematicMapBaseURL = `${window.apiSchema}://${window.apiSchematicMapUrl}/api/v1/`;
